module.exports = __webpack_public_path__ + "media/Ringtone5.9619e7d4.mp3";